import {IServiceAction, postRequest} from "redux-request-middleware";
import {IMarketingTrackingParams, IUTMParams} from "StateInterface";
import {changeAuthExternalStatus} from "service";
import {gatewayUrl, googleLoginVersion} from "config";
import {push} from "connected-react-router";
import {lsRmItem, tokenUtility} from "utils/secure";
import {LoginMode} from "login/reducer";

export enum Actions {
  REQUEST_SIGN_IN = "REQUEST_SIGN_IN",
  AUTHENTICATE_LOGOUT = "AUTHENTICATE_LOGOUT",
  RESET_AUTH = "RESET_AUTH",
  SET_LOADING = "SET_LOADING",
  SET_EXT_AUTH_PARAM = "SET_EXT_AUTH_PARAM",
  REQUEST_OTP_REGISTERED = "REQUEST_OTP_REGISTERED",
  REQUEST_UPDATE_EMAIL = "REQUEST_UPDATE_EMAIL",
  CLEAR_UPDATE_EMAIL_PROPS = "CLEAR_UPDATE_EMAIL_PROPS",
  SET_CURRENT_FLOW_CHANNEL = "SET_CURRENT_FLOW_CHANNEL",
  SET_ANDROID = "SET_ANDROID",
  SET_API_VERSION = "SET_API_VERSION",
  SET_TWO_FACTOR_AUTH = "SET_TWO_FACTOR_AUTH",
  PARTNER_SIGN_IN = "PARTNER_SIGN_IN",
  SET_ACCESS_TOKEN_LOGIN = "SET_ACCESS_TOKEN_LOGIN",
  SET_PARTNER_ANDROID = "SET_PARTNER_ANDROID",
}

export interface IAction extends IServiceAction<Actions, IRequestBody, {}, {}> {
  status?: string;
  value?: any;
}

export interface IRequestBody {
  facebookToken: string;
}

export function googleSignIn(
    marketingTrackingParams: IMarketingTrackingParams,
    loginChannel: string,
    sourcingCode: string,
    utmParams: IUTMParams,
    leadId: string,
    ) {
  return (dispatch) => {
    dispatch(
      postRequest(
        Actions.REQUEST_SIGN_IN,
        "/hagrid/signin/google",
        {
            loginChannel,
            marketingTrackingParams,
            sourcingCode,
            utmParams,
            leadId,
        },
        true,
          null,
          null,
          gatewayUrl,
      ),
    );
  };
}
export function hagridSignIn(user) {
  return {type: `${Actions.REQUEST_SIGN_IN}_SUCCESS`, body: user};
}
export function resetAuth() {
  return {type: Actions.RESET_AUTH};
}
export function setAndroid() {
    return {type: Actions.SET_ANDROID};
}
export function setPartnerAndroid() {
  return {type: Actions.SET_PARTNER_ANDROID};
}
export function setCurrentFlowChannel(channel) {
    return {type: Actions.SET_CURRENT_FLOW_CHANNEL, body: channel};

}
export function setPartnerLogin(loginDetails: {userId: number, roles: string[]}) {
  return {type: Actions.PARTNER_SIGN_IN, body: loginDetails};
}
export function logout(nextPath, search = "", loginMode: LoginMode, state?: {[key: string]: any}) {
  return (dispatch) => {
    if ((window as any).gapi && (window as any).gapi.auth2 && loginMode === LoginMode.V1) {
      (window as any).gapi.auth2
        .getAuthInstance()
        .signOut()
        .then(
          () => {
            dispatch({type: Actions.AUTHENTICATE_LOGOUT});
            changeAuthExternalStatus();
            dispatch(push({
              pathname: nextPath,
              search,
              state
            }));
          });
    } else if (googleLoginVersion === "V2" && loginMode === LoginMode.V1) {
      dispatch({type: Actions.AUTHENTICATE_LOGOUT});
      changeAuthExternalStatus();
      dispatch(push({
        pathname: nextPath,
        search,
        state,
      }));
      lsRmItem("user");
      tokenUtility().rmStoredToken();
    } else {
      dispatch({type: Actions.AUTHENTICATE_LOGOUT});
        changeAuthExternalStatus();
        dispatch(push({
          pathname: nextPath,
          search,
          state
      }));
    }
  };
}

export function sendUpdateEmailOtp(mobile: string, pan: string) {
    return (dispatch) => {
        dispatch(
          postRequest(
            Actions.REQUEST_OTP_REGISTERED,
            "/hagrid/forgot-email",
            {mobile, pan},
            false,
            null,
            null,
            gatewayUrl,
          ),
        );
    };
}

export function updateEmailFromHagrid(otp: number, requestId: string) {
  return (dispatch) => {
      dispatch(
          postRequest(
              Actions.REQUEST_UPDATE_EMAIL,
              "hagrid/forgot-email-update",
              {otp, requestId},
              true,
              null,
              null,
              gatewayUrl,
          ),
      );
  };
}

export function clearUpdateEmailProps() {
    return {type: Actions.CLEAR_UPDATE_EMAIL_PROPS};
}
export function setApiVersion(body: object) {
    return {type: Actions.SET_API_VERSION, body};
}

export function setAuthParameters(body) {
    return {type: Actions.SET_EXT_AUTH_PARAM, body};
}
export function setLoading(value: boolean) {
  return {type: Actions.SET_LOADING, value};
}
export function setTwoFactorAuth(body: object) {
  return {type: Actions.SET_TWO_FACTOR_AUTH, body};
}
export function setAccessTokenAuth(body: object) {
  return {type: Actions.SET_ACCESS_TOKEN_LOGIN, body};
}
